/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 5c7e3adbcb7bcaf4de0f4c1490bc6f3a */

import { ConcreteRequest } from "relay-runtime";

export type SetLangCookieInput = {
    locale?: string | null | undefined;
    cookieDomain?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type setLangCookieMutationVariables = {
    input: SetLangCookieInput;
};
export type setLangCookieMutationResponse = {
    readonly setLangCookie: {
        readonly clientMutationId: string | null;
    } | null;
};
export type setLangCookieMutation = {
    readonly response: setLangCookieMutationResponse;
    readonly variables: setLangCookieMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SetLangCookiePayload",
            "kind": "LinkedField",
            "name": "setLangCookie",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "setLangCookieMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "setLangCookieMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/setLangCookieMutation",
            "metadata": {},
            "name": "setLangCookieMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'fd787194fded1ecfdb78628ca23499b1';
export default node;
